var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{staticClass:"mt-2 mt-md-4 w-100 logo",attrs:{"src":require('../../assets/img/svg/muniman-Logo-white.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }